import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, Info, TrendingDown, TrendingUp } from 'lucide-react';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Badge } from '../../performance-operations/styles';
import { insightParams } from '../config';

// Analiz §14 E11 AI alanı — kural tabanlı bulgular (sayılar sunucuda hesaplanır; LLM yok): en az 3 karşılaştırılabilir kapanmış
// dönemde tek yönlü hareket "eğilim", iki dönemde yalnız "değişim"; hedef düşüşü (AI02: −10 yp, n ≥ 20, kapsama ≥ %80) ve kıyas
// sınırlamaları (ölçek, yöntem, rol, içe aktarılan dönem, geçişte alınmış tarihsel görünüm, güncel organizasyon).
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled.li`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
  border-left: 3px solid ${({ theme, $warning }) => ($warning ? theme.colors.auxiliar.warning : theme.colors.primary.main)};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const iconOf = (code) => {
  if (code === 'trendUp') return TrendingUp;
  if (code === 'trendDown' || code === 'goalDrop') return TrendingDown;
  if (code.startsWith('limitation.')) return AlertTriangle;
  return Info;
};

export default function TrendInsightsPanel({ panel }) {
  const { t, i18n } = useTranslation();
  const insights = panel.data?.insights || [];
  return (
    <PanelCard
      panelKey="trendInsights" title={t('performance.trends.panel.insights')} span={5}
      loading={panel.loading} error={panel.error} onRetry={panel.retry} empty={insights.length === 0}
      emptyText={t('performance.trends.insight.none')}
    >
      <List>
        {insights.map((ins, i) => {
          const Icon = iconOf(ins.code);
          const params = insightParams(ins, i18n.language);
          const metric = ins.metric ? t(`performance.trends.metric.${ins.metric}`) : '';
          return (
            <Item key={`${ins.code}-${i}`} $warning={ins.severity === 'warning'} data-insight={ins.code}>
              <Icon size={16} aria-hidden="true" />
              <div>
                {t(`performance.trends.insight.${ins.code}`, { ...params, metric })}
                {ins.metric ? <>{' '}<Badge>{ins.metric}</Badge></> : null}
              </div>
            </Item>
          );
        })}
      </List>
    </PanelCard>
  );
}
